import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'cpfCnpj',
    standalone: true
})
export class CpfCnpjPipe implements PipeTransform {

    transform(value: string | null | undefined): string {
        if (!value) {
            return '';
        }

        // Remove tudo que não é dígito
        const cleanValue = value.replace(/\D/g, '');

        // Verifica se é CNPJ (14 dígitos) ou CPF (11 dígitos)
        if (cleanValue.length === 14) {
            // Formato CNPJ: 00.000.000/0000-00
            return cleanValue.replace(
                /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
                '$1.$2.$3/$4-$5'
            );
        } else if (cleanValue.length === 11) {
            // Formato CPF: 000.000.000-00
            return cleanValue.replace(
                /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
                '$1.$2.$3-$4'
            );
        }

        // Retorna o valor original se não for CNPJ nem CPF
        return value;
    }
}

